// extracted by mini-css-extract-plugin
module.exports = {"main":"SearchTemplate_main__d8d6u","content":"SearchTemplate_content__CWjB5","search-fade-in":"SearchTemplate_search-fade-in__rQFRg"};